class SectionFeatureCallouts extends HTMLElement {
  constructor() {
    super();
    this.callouts = this.querySelectorAll('.feature-callouts__callout');
    this.calloutContents = this.querySelectorAll('.feature-callouts__content');
    this.documentRulers = this.querySelectorAll('.document-ruler');
    this.initFunction();
  }

  initFunction() {
    this.callouts.forEach((callout) => {
      callout.addEventListener('click', () => {
        const calloutContent = this.querySelector(`.feature-callouts__content[data-content="${callout.dataset.content}"]`);

        if (callout.classList.contains('active')) {
          return;
        } else {
          // Remove the "active" class from all callouts
          this.callouts.forEach((c) => {
            c.classList.remove('active');
          });
          this.calloutContents.forEach((c) => {
            c.classList.remove('active');
          });          
          // Add the "active" class to the clicked callout
          callout.classList.add('active');
          // Add the "active" class to the clicked callout
          calloutContent.classList.add('active');
        }
      });
    });
  }
}

if (!customElements.get("section-feature-callouts")) {
  customElements.define("section-feature-callouts", SectionFeatureCallouts);
}
